import PropTypes from 'prop-types';
import { css } from '@emotion/react';

const svgIconCss = css`
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-flex;
  fill: currentColor;
  flex-shrink: 0;
  font-size: inherit;
`;

/**
 *
 * Generic wrapper for SVG icons.
 * Icon normalization of width and height is by 1em, meaning it will scale to
 * font size of the parent.
 *
 * @example
 * <SvgIcon {...props}>
 *   <g fill="none" fillRule="evenodd">
 *     <path
 *       stroke="currentColor"
 *       strokeLinecap="round"
 *       strokeWidth="2.4"
 *       d="M7 10l4.958 5L17 10.004"
 *     />
 *   </g>
 * </SvgIcon>
 *
 * @param {object} props
 */

function SvgIcon({
  children,
  className,
  component: Component = 'svg',
  viewBox = '0 0 24 24',
  color,
  ...other
}) {
  return (
    <Component
      css={svgIconCss}
      className={className}
      focusable="false"
      viewBox={viewBox}
      color={color}
      {...other}
    >
      {children}
    </Component>
  );
}

SvgIcon.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  viewBox: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a React component.
   */
  component: PropTypes.elementType,
  /** Color attribute to the SVG element. */
  color: PropTypes.string,
};

export default SvgIcon;
